import { useTenants } from "@visioni/a3s-dir/app";
import { useEnvironment } from "@src/config/environment-store";
import { directory } from "@src/config/runtime";
import { authenticatedFetch } from "../auth";
import { useAuthReady } from "../auth/auth-store";

/** Shared directory tenants query; same cache entry as `TenantProvider`. */
export const useAppDirectoryTenants = () => {
  const env = useEnvironment();
  const authReady = useAuthReady();
  return useTenants({
    authenticatedFetch,
    directoryBaseUrl: directory(env),
    enabled: authReady,
  });
};
